import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';

function CannotAddMultipleAlertsModal({ show, onHide }) {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Body>
        <p>
          On your current Account Level, you can only create one alert at a time.
          Please remove sensors so that only one is selected.
        </p>
        <p className="mt-2">
          To create alerts in bulk,
          {' '}
          <a href="/s/subscription/billing/change-plan">upgrade</a>
          {' '}
          to the Enterprise level or higher.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onHide}>
          Dismiss
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

CannotAddMultipleAlertsModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
};
export default CannotAddMultipleAlertsModal;
